export default {
  optionUnavailable: 'optionUnavailable',
  preorder: 'preorder',
  comingSoon: 'comingSoon',
  booking: 'booking',
  discontinued: 'discontinued',
  unavailable: 'unavailable',
  oneAvailable: 'oneAvailable',
  available: 'available',
  discontinued: 'discontinued',
  qtyDiscontinued: 'qtyDiscontinued',
  qtyUnavailable: 'qtyUnavailable',
  soonAvailable: 'soonAvailable',
};
